import type { TranslationKey } from "@/modules/i18n/components/types"

export const restoreKeyIfSharedTranslation = (i18nKey: TranslationKey, condition: boolean = true): string => {
  return condition && i18nKey.startsWith("shared") ? i18nKey.replace(/^shared_/, "shared.") : i18nKey
}
